var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2624 1.16699H5.37409C3.25076 1.16699 1.98492 2.43283 1.98492 4.55616V9.43866C1.98492 11.5678 3.25076 12.8337 5.37409 12.8337H10.2566C12.3799 12.8337 13.6458 11.5678 13.6458 9.44449V4.55616C13.6516 2.43283 12.3858 1.16699 10.2624 1.16699ZM9.77826 8.34199C9.94742 8.51116 9.94742 8.79116 9.77826 8.96033C9.69076 9.04782 9.57992 9.08866 9.46909 9.08866C9.35826 9.08866 9.24742 9.04782 9.15992 8.96033L7.81826 7.61866L6.47659 8.96033C6.38909 9.04782 6.27826 9.08866 6.16742 9.08866C6.05659 9.08866 5.94576 9.04782 5.85826 8.96033C5.68909 8.79116 5.68909 8.51116 5.85826 8.34199L7.19992 7.00033L5.85826 5.65866C5.68909 5.48949 5.68909 5.20949 5.85826 5.04033C6.02742 4.87116 6.30742 4.87116 6.47659 5.04033L7.81826 6.38199L9.15992 5.04033C9.32909 4.87116 9.60909 4.87116 9.77826 5.04033C9.94742 5.20949 9.94742 5.48949 9.77826 5.65866L8.43659 7.00033L9.77826 8.34199Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/rejected.716d34ac0bcb9fd44fa597ab9e5ecba3.svg";
export { ForwardRef as ReactComponent };